import { imageSet } from "@/data/siteData";

export const ResponsiveImage = ({ slug, alt, sizes = "(max-width: 760px) 100vw, 50vw", className = "", testId, eager = false }) => {
  const image = imageSet(slug);
  return (
    <picture>
      <source type="image/webp" srcSet={image.srcSet} sizes={sizes} />
      <img
        src={image.src}
        srcSet={image.srcSet}
        sizes={sizes}
        alt={alt}
        className={className}
        loading={eager ? "eager" : "lazy"}
        fetchPriority={eager ? "high" : "auto"}
        width="1280"
        height="960"
        data-testid={testId}
      />
    </picture>
  );
};
